import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useMessageBus } from "@jti/fe-message-bus";
import { useTranslations } from "@jti/ui";
export const useAddProduct = (sku, bundle, isFreeTrial = false, onErrorCallback = () => undefined) => {
    const { __ } = useTranslations();
    const [isRunning, setIsRunning] = useState(false);
    const messageBus = useMessageBus();
    useEffect(() => {
        messageBus.subscribe({
            channel: "success.cart.add",
            callback: () => {
                toast.success(__("productdetails.addproduct.success"));
                setIsRunning(false);
                const headerElement = window.document.querySelector(".header__container");
                if (headerElement) {
                    headerElement.classList.remove("header__container--hide");
                }
            },
        });
        messageBus.subscribe({
            channel: "fail.cart.add",
            callback: ({ payload: { message } }) => {
                toast.error(__(message));
                setIsRunning(false);
                if (onErrorCallback) {
                    onErrorCallback();
                }
            },
        });
        return () => {
            messageBus.unsubscribe("success.cart.add");
            messageBus.unsubscribe("fail.cart.add");
        };
    }, [messageBus, onErrorCallback]);
    const addProductToCart = (quantity = 1, currentBundles) => {
        if (isRunning) {
            return;
        }
        setIsRunning(true);
        messageBus.publish("cart.add", {
            payload: {
                sku,
                bundle: currentBundles ?? bundle,
                quantity,
                isFreeTrial,
            },
        }, { sticky: true });
    };
    return {
        isRunning,
        addProductToCart,
    };
};
//# sourceMappingURL=useAddProduct.js.map